import includes from 'lodash/includes';
// Generate props for PlanPredictedItem, PlanPublishedItem
export const getSelectionPropsForCheckbox = ({
  selectedItems = [],
  setSelectedItems = () => {},
  customContainsFunc = (items, item) => {
    return includes(items, item);
  },
} = {}) => {
  // eslint-disable-next-line no-shadow
  const isSelected = (selectedItems, index) => customContainsFunc(selectedItems, index);
  const onSelectionChange = ({ index, checked }) => {
    if (checked && !customContainsFunc(selectedItems, index)) {
      setSelectedItems([...selectedItems, index]);
    } else if (!checked) {
      setSelectedItems(selectedItems.filter((i) => !customContainsFunc([index], i)));
    }
  };
  return { isSelected, onSelectionChange };
};

// Generate props for SelectedItemsControls
export const getSelectionPropsForSelectAll = ({
  selectedItemsByTab = {},
  setSelectedItemsByTab = () => {},
  activeTab,
  activeTabData,
} = {}) => {
  const activeTabCount = activeTabData ? activeTabData.length : 0;
  const selectedItemsCountForActiveTab = selectedItemsByTab[activeTab] && selectedItemsByTab[activeTab].length;

  const allItemsSelected = activeTabCount > 0 && selectedItemsCountForActiveTab === activeTabCount;
  const currentSelectedItems = Object.values(selectedItemsByTab).reduce((memo, indexes) => (indexes ? memo + indexes.length : memo), 0);
  const someItemsSelected = selectedItemsCountForActiveTab > 0 && !allItemsSelected;
  const checkAllItems = () => {
    return allItemsSelected ? setSelectedItemsByTab(activeTab, []) : setSelectedItemsByTab(activeTab, activeTabData);
  };

  return { allItemsSelected, currentSelectedItems, someItemsSelected, checkAllItems };
};
